<template lang="pug">
.procurement-negotiation(v-loading="loading")
  title-bar(style="display:flex;")
    span(
      style="margin-right: 10px"
    ) {{ quotationData[0].star_name }}
    el-button(
      v-if="currentTask && currentTask.can_view && currentTask.status !== '已完成'"
      type="text"
      @click="visible = true"
    ) {{ $t('修改') }}
  .section-divider(
    style="margin:0px 0"
  )
  unistar-tables(
    v-for="(item, i) in quotationData"
    :index="i"
    :key="i"
    :starData="item"
  )
  el-row(:gutter="20" style="margin-left:15px" v-if="currentTask && currentTask.status !== '已完成' && currentTask.can_view")
    el-col.btn-group(:offset="3" :span="21" style="width:710px")
      el-button(
        @click="handleUpdate"
        type="primary"
      ) {{ $t('更新') }}
      el-button(
        @click="submit"
        type="primary"
      ) {{ $t('提交') }}
      el-button(
        type="plain"
      ) {{ $t('取消') }}
  .section-divider(v-if="starPriceHistory.length")
  template(v-if="starPriceHistory.length")
    title-bar {{ $t('谈判记录') }}
    .audit-versions__item(v-for="(item, i) in starPriceHistory")
      .audit-versions__item__title
        .info
          span(style="margin: 0 10px 0 5px") {{ item.create_date | formatDate }}
        el-button(
          type="text"
          @click="handleViewHistoryDialog(i)"
        ) {{ $t('查看详情') }}>>
  unistar-quotation-dialog(
    :visible="visible"
    :title="$t('修改报价')"
    v-if="visible"
    :data="quotationDetail[0]"
    :index="0"
    @close="handleDialogClose"
    @confirm="handleDialogConfirm"
    :executionPriceRequired="true"
  )
  unistar-history-quotation-dialog(
    v-if="dialogVisible"
    :visible="dialogVisible"
    :tableData="starPriceHistory[selectedIndex].star"
    @closeDialog="dialogVisible = false"
  )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import { formatDate, format4backend } from '@/umcc/util'
import UnistarTables from '@/components/UnistarTables'
import axios from 'axios'
import UnistarQuotationDialog, { normalizeQuotation } from '@/components/UnistarQuotationDialog'
import { pickBy, cloneDeep } from 'lodash'
import UnistarHistoryQuotationDialog from '@/components/UnistarHistoryQuotationDialog'

function formatQuotationParams (quotationData, processType, campaignId) {
  let res = {
    campaign_id: campaignId,
    process_type: processType
  }
  res.star_info = quotationData.map(i => {
    return {
      star_id: i.star_id
    }
  })
  res.star_offer_date = quotationData.map(i => {
    return [{
      start_date: i.star_offer_date.start_date,
      end_date: i.star_offer_date.end_date
    }]
  })
  res.star_offer_price = quotationData.map(i => {
    return i.star_offer_price.price.map(j => {
      const res = {
        star_service_id: j.star_service_id,
        star_service_item_id: j.star_service_item_id,
        unit_price: j.unit_price,
        number: j.number,
        total_price: j.total_price
      }
      return pickBy(res, v => { return v != null })
    })
  })
  res.star_service_item = quotationData.map(i => {
    return i.star_offer_price.price.map(j => {
      return [{
        star_service_item_name: j.star_service_item_name
      }]
    })
  })
  res.star_right_price = quotationData.map(i => {
    return i.star_right_price.price.map(j => {
      const res = {
        right_service_id: j.right_service_id,
        right_service_item_id: j.right_service_item_id,
        workday: j.workday,
        number: j.number,
        is_confirmed: j.is_confirmed
      }
      return pickBy(res, v => { return v != null })
    })
  })
  res.right_service_item = quotationData.map(i => {
    return i.star_right_price.price.map(j => {
      return [{
        right_service_item_name: j.right_service_item_name
      }]
    })
  })
  res.star_execution_price = quotationData.map(i => {
    return i.star_execution_price.price.map(j => {
      const res = {
        star_service_id: j.star_service_id,
        star_service_item_id: j.star_service_item_id,
        unit_price: j.unit_price,
        number: j.number,
        total_price: j.total_price
      }
      return pickBy(res, v => { return v != null })
    })
  })
  res.star_service_item_execution = quotationData.map(i => {
    return i.star_execution_price.price.map(j => {
      return [{
        star_service_item_name: j.star_service_item_name
      }]
    })
  })
  return res
}

export default {
  data () {
    return {
      quotationData: [], // 原始明星报价
      quotationDetail: [], // format过的报价,
      visible: false,
      loading: false,
      starPriceHistory: [],
      selectedIndex: 0,
      dialogVisible: false
    }
  },
  components: {
    TitleBar,
    UnistarTables,
    UnistarQuotationDialog,
    UnistarHistoryQuotationDialog
  },
  filters: {
    formatDate
  },
  mounted () {
    this.getStarPrice()
    this.getStarPriceHistory()
  },
  computed: {
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    currentTask () {
      return this.$store.state.unistar.sowProcess.find(task => this.$route.path.includes(task.action))
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    }
  },
  methods: {
    getStarPriceHistory () {
      axios.get('/management/star/getStarPriceHistory', {
        params: {
          campaign_id: this.campaignInfo.campaign_id
        }
      }).then(res => {
        this.starPriceHistory = res
      })
    },
    getStarPrice () {
      this.loading = true
      axios.get('/management/star/getConfirmedStarPrice', {
        params: {
          campaign_id: this.campaignInfo.campaign_id,
          process_type: 2
        }
      })
        .then(res => {
          this.loading = false
          let arr = [res]
          this.quotationData = cloneDeep(arr)
          this.quotationDetail = arr.map(i => normalizeQuotation(i))
        })
    },
    handleDialogClose (res) {
      this.visible = false
    },
    handleDialogConfirm (res) {
      this.visible = false
      this.quotationData[0] = res
      this.quotationDetail[0] = res
    },
    validateQuotationParams () {
      const res = this.quotationDetail.map(i => {
        return i.star_execution_price.price.every(j => j.star_service_id)
      })
      return res[0]
    },
    async handleUpdate () {
      if (!this.validateQuotationParams()) {
        this.$message.error(this.$t('请填写执行价目表'))
        return
      }
      this.loading = true
      const params = formatQuotationParams(this.quotationDetail, 2, this.campaignInfo.campaign_id)
      try {
        await axios.post('/management/star/saveStarPrice', format4backend(params))
        this.getStarPriceHistory()
        this.loading = false
        this.$message.success(this.$t('更新成功'))
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    async submit () {
      if (!this.validateQuotationParams()) {
        this.$message.error(this.$t('请填写执行价目表'))
        return
      }
      this.loading = true
      try {
        await this.handleUpdate()
        await axios.get('/management/star/approveQuotation', {
          params: {
            task_id: this.currentTask.taskId,
            campaign_id: this.campaignInfo.campaign_id,
            remark: this.remark
          }
        })
        await this.$store.dispatch('unistar/getProcessTasks', {
          business_key: this.campaignInfo.campaign_id,
          business_type: this.sowInfo.business_type,
          phase_type: 1
        })
        this.loading = false
        this.$message.success(this.$t('提交成功'))
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    handleViewHistoryDialog (index) {
      this.dialogVisible = true
      this.selectedIndex = index
    }
  }
}
</script>

<style lang="stylus">
.procurement-negotiation
  .btn-group
    display flex
    justify-content flex-end
  .audit-versions__item
    width 400px
    margin-bottom 10px
    margin-top 10px

  .audit-versions__item__title
    display flex
    align-items center
    justify-content space-between
    background #edf2fa
    padding 0 30px
    height 42px
    .info
      span
        color #2c3031
        font-size 14px
        font-weight 500
    .el-button
      color #5f99f6 !important
</style>
